import CerticSvg from "./../svgComponents/CerticSvg"
import DiscordSvg from "./../svgComponents/DiscordSvg"
import MediumSvg from "./../svgComponents/MediumSvg"
import TelegramSvg from "./../svgComponents/TelegramSvg"
import TicTocSvg from "./../svgComponents/TicTocSvg"
import XSvg from "./../svgComponents/XSvg"
import YoutubeSvg from "./../svgComponents/YoutubeSvg"
import ZeallySvg from "./../svgComponents/ZeallySvg"

export const  socialMediaLinks = [
  {
  id: 1,
  name: 'X',
  href: "https://x.com/XBRLab",
  linkImage: <XSvg />,
},
{
  id: 2,
  name: 'Telegram',
  href: 'https://t.me/XBRLab',
  linkImage: <TelegramSvg />,
},
{
  id: 3,
  name: 'Discord',
  href: 'https://discord.com/invite/BuuU42S4H7',
  linkImage: <DiscordSvg />,
},
{
  id: 4,
  name: 'Youtube',
  href: 'https://www.youtube.com/channel/UCWqI45JHWQYegDLNoLjjXvg',
  linkImage: <YoutubeSvg />,
},
{
  id: 5,
  name: 'Tictoc',
  href: 'https://www.tiktok.com/@xbrlab?_t=8jRKM4Yw5ht&_r=1',
  linkImage: <TicTocSvg />,
},
{
  id: 6,
  name: 'Medium',
  href: 'https://medium.com/@XBRLab',
  linkImage: <MediumSvg />,
},
{
  id: 7,
  name: 'Certic',
  href: '#',
  linkImage: <CerticSvg />,
},
{
  id: 8,
  name: 'Zeally',
  href: '#',
  linkImage: <ZeallySvg />,
},
]